import axios from 'axios';
import qs from 'querystring';
// import store from '../stores/index';
import api from '../configs/api.config';
import { Message } from 'view-design';

export const API = api;
export const BASE_URL = '';
const TIME_OUT = 15000;

axios.defaults.withCredentials = true;

const processStatus = [200, 201, 202, 203, 204, 205, 206, 300, 400, 401, 403, 406];

export const service = axios.create({
  baseURL: BASE_URL,
  timeout: TIME_OUT,
  headers: {
    'content-type': 'application/json',
  },
  validateStatus(status) {
    return processStatus.indexOf(status) > -1;
  },
});

service.interceptors.request.use(
  config => {
    config.headers['Zone-Id'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers['Accept-Language'] = Intl.DateTimeFormat().resolvedOptions().locale;
    if (config.headers['content-type'] === 'application/x-www-form-urlencoded') {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  error => {
    Message.error({
      content: error.message,
      duration: 3,
    });
    return Promise.reject(error);
  },
);

export function get(api, body = {}, headers = {}) {
  const hasQuery = api.url.indexOf('?') > -1;
  let url = `${api.url}${hasQuery ? '&' : '?'}${qs.stringify(body)}`;
  if (api.type === 'form') {
    headers['content-type'] = 'application/x-www-form-urlencoded';
  } else if (api.type === 'json') {
    headers['content-type'] = 'application/json';
  }
  return service
    .get(url, {
      headers: headers,
    })
    .then(res => {
      return res;
    });
}

export function post(api, body = {}, headers = {}) {
  if (api.type === 'form') {
    headers['content-type'] = 'application/x-www-form-urlencoded';
  } else if (api.type === 'json') {
    headers['content-type'] = 'application/json';
  }
  return service.post(api.url, body, { headers: headers }).then(res => {
    return res;
  });
}

export function postFile2ImageBase64(api, body = {}, headers = {}) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: api.url,
      responseType: 'blob',
      baseURL: BASE_URL,
      timeout: TIME_OUT,
      data: body,
      headers: headers,
    })
      .then(res => {
        if (res.status === 200) {
          var blob = res.data;
          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = function(e) {
            resolve(e.target.result);
          };
          reader.onerror = function() {
            throw new Error('fresh captcha image error');
          };
        } else {
          throw new Error(res.statusText);
        }
      })
      .catch(e => {
        reject(e);
      });
  });
}

export default post;
